<template>
  <div class="component-filter-select">
    <div class="inner-wrap">
      <div class="content">
        <!-- <vxe-input type="text" v-model="option.data" @keyup="keyupEvent" @input="changeOptionEvent"></vxe-input> -->
        <el-select v-model="option.data" multiple :filterable="filterable"  @input="changeOptionEvent" size="mini" :placeholder="$t('placeholder.please_select')">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="footer">
        <vxe-button @click="resetEvent" size="mini">{{ $t("button.clear") }}</vxe-button>
        <vxe-button status="primary" @click="confirmEvent" size="mini" :disabled="!option.data">{{ $t("button.confirm") }}</vxe-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterMultiSelect',
  props: {
    params: Object,
    renderOpts: Object
  },
  data () {
    return {
      column: null,
      option: null,
      options: [],
      filterable: false
    }
  },
  created () {
    this.load()
    if(this.renderOpts.selectedOptions) {
      this.option.data = this.renderOpts.selectedOptions;
    }
    if(this.column) {
      this.changeOptionEvent();
    }
  },
  methods: {
    load () {
      const { column } = this.params
      const option = column.filters[0]
      this.column = column
      this.option = option
      this.options = this.renderOpts.options
      this.filterable = this.renderOpts.filterable
    },
    changeOptionEvent () {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data
      $panel.changeOption(null, checked, option)
    },
    keyupEvent ({ $event }) {
      const { params } = this
      const { $panel } = params
      if ($event.keyCode === 13) {
        $panel.confirmFilter()
      }
    },
    confirmEvent () {
      const { $panel } = this.params
      $panel.confirmFilter()
      console.log("select: ",this);
    },
    resetEvent () {
      const { $panel } = this.params
      $panel.resetFilter()
    }
  }
}
</script>

<style lang="scss">
.component-filter-select {
  padding: 10px;
  .footer{
    margin-top: 5px;
  }
}
</style>